import type { MutableRefObject, LegacyRef, RefCallback } from 'react';
import { isNotNil, isFunction } from '@wistia/type-guards';

export const mergeRefs =
  // eslint-disable-next-line @typescript-eslint/no-deprecated
  <T = unknown>(refs: (LegacyRef<T> | MutableRefObject<T> | null | undefined)[]): RefCallback<T> =>
    (value) => {
      refs.forEach((ref) => {
        if (isFunction(ref)) {
          ref(value);
          return;
        }

        if (isNotNil(ref)) {
          // eslint-disable-next-line @typescript-eslint/no-deprecated
          (ref as MutableRefObject<T | null>).current = value; // eslint-disable-line no-param-reassign
        }
      });
    };
